import { createSlice } from '@reduxjs/toolkit'
import Constants from '../../Constants'

export const ProjectInfoSlice = createSlice(
  {
  name: 'project_info',
  initialState: {
    value: {},
  },
  reducers: {
    updateProjectInfo: (state, action) => {
      if(action.payload.type){
          return { ...state,
              value:{
                ...state.value,[action.payload.type]: action.payload.value
              }              
          }
      }
      else{
        state.value = action.payload
      }
      
    },
    updateDepartment: (state, action) => {
      state.value.userGroup = action.payload
    },
    updateSourceLanguage: (state, action) => {
      state.value.sourceLanguage = action.payload
    },
    updateTargetLanguage: (state, action) => {
      state.value.targetLanguages = action.payload
    },
    updateProjectContentType: (state, action) => {
      state.value.projectContentType = action.payload
      if(action.payload === Constants.STANDARD_CONTENT_TYPE) {
        state.value.projectContentTypeDisplay = Constants.STANDARD_CONTENT_TYPE_DISPLAY;
      } else if(action.payload === Constants.ELOQUA){
        state.value.projectContentTypeDisplay = Constants.ELOQUA_CONTENT_TYPE_DISPLAY;
      } else if(action.payload === Constants.MARKETOREST){
        state.value.projectContentTypeDisplay = Constants.MARKETOREST_CONTENT_TYPE_DISPLAY;
      } else if(action.payload === Constants.BRIGHTCOVE){
        state.value.projectContentTypeDisplay = Constants.BRIGHTCOVE_CONTENT_TYPE_DISPLAY;
      } else if(action.payload === Constants.PARDOT){
        state.value.projectContentTypeDisplay = Constants.PARDOT_CONTENT_TYPE_DISPLAY;
      }
        else if(action.payload === Constants.UBERFLIP){
          state.value.projectContentTypeDisplay = Constants.UBERFLIP_CONTENT_TYPE_DISPLAY;
    }
    },
    updateProjectFollowers: (state, action) => {
      state.value.projectFollowers = action.payload
    },
    updateProjectWorkflow: (state, action) => {
      state.value.projectWorkflows = action.payload
    },
    updateStatus: (state, action) => {
      state.value.status = action.payload;
    },
    updateCredentialsSet: (state, action) => {
      state.value.credentialsSet = action.payload
    },
    updateAssets: (state, action) => {
      state.value.assets = action.payload
    },
    updateNextStepEvent: (state, action) => {
          state.value.nextStepEvent = action.payload
    },
  },
})

export const { updateProjectInfo, updateDepartment, updateSourceLanguage, updateTargetLanguage, updateProjectContentType, updateProjectFollowers, updateProjectWorkflow, updateStatus, updateCredentialsSet, updateAssets, updateNextStepEvent} = ProjectInfoSlice.actions

export default ProjectInfoSlice.reducer